import * as Trainer from "./trainer";
import * as Shop from "./shop";
import * as Leaderboard from "./leaderboard";

const PCGApi = {
  Trainer,
  Shop,
  Leaderboard
};

export { PCGApi };
